// Copyright (c) 2018 Deere & Company

export const isInfoRequestFormInvalid = (returnStatusId, infoRequestForm) => {

    let areCommentsRequired,
        isInformationRequired;

    areCommentsRequired = false;
    isInformationRequired = false;

    if (returnStatusId === '7') {

        areCommentsRequired = !infoRequestForm.courierInfo.comments.trim();

        isInformationRequired = infoRequestForm.questions.some(question => question.answer !== '');

    }

    const areMandatoryAnswersRequired = returnStatusId !== '7' && infoRequestForm.questions.findIndex(item => item.isMandatory && !item.answer.trim()) > -1;

    return isInformationRequired || areCommentsRequired || areMandatoryAnswersRequired;

};

export const isPartRequestFormValid = (returnStatusId, partRequestForm) => {

    if (returnStatusId === '7') {

        return [
            partRequestForm.courierInfo.comments.trim(),
            partRequestForm.dispatchDate
        ].every(condition => condition);

    }

    return [
        partRequestForm.courierInfo.courierName.trim(),
        partRequestForm.dispatchDate,
        partRequestForm.courierInfo.returnTrackingNumber.trim()
    ].every(condition => condition);

};

export const isPictRequestFormInvalid = (returnStatusId, pictRequestForm) => {

    let areCommentsRequired;

    areCommentsRequired = false;

    if (returnStatusId === '7') {

        areCommentsRequired = !pictRequestForm.courierInfo.comments.trim();

    }

    const areFilesRequired = () => {

        if (returnStatusId !== '7' && pictRequestForm.files.length < 1) {

            return true;

        }

        if (returnStatusId === '7' && pictRequestForm.files.length) {

            return true;

        }

        return false;

    };

    return areCommentsRequired || areFilesRequired();

};



// WEBPACK FOOTER //
// ./src/part-requests/request-details/services/is-form-valid.js